import { STORAGE_KEY } from '@/constant/constant';
import { getShopifyUserId, companyUUID, getQueryVariable } from '@/service/api';
import { getLocal } from '@/utils/storage';

export function get(data, fn, errFn) {
  var xhr = new XMLHttpRequest();
  xhr.open('GET', data.url, true);
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4) {
      var responseText;
      try {
        responseText = JSON.parse(xhr.responseText);
      } catch (e) {
        responseText = xhr.responseText;
      }
      if (xhr.status === 200 || xhr.status === 304) {
        fn && fn.call(this, responseText);
      } else {
        errFn && errFn.call(this, responseText);
      }
    }
  };
  xhr.send();
}

export function post(data, fn?: any) {
  var xhr = new XMLHttpRequest();
  xhr.open('POST', data.url, true);
  xhr.setRequestHeader('Content-Type', data.contentType || 'application/json');
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && (xhr.status === 200 || xhr.status === 304)) {
      var responseText;
      try {
        responseText = JSON.parse(xhr.responseText);
      } catch (e) {
        responseText = xhr.responseText;
      }
      fn && fn.call(this, responseText);
    }
  };
  xhr.send(data.data);
}

export const CARTXTRACK_URL = 'https://59b517704ce43f0f.cartseekite.com/cartxtrack';
export function customerCreate(d) {
  const p = {
    eventType: 'Customer/Create',
    companyUUID,
    email: d.email,
    phone: d.phone,
    cid: getQueryVariable('cid') || getLocal(STORAGE_KEY.CARTX_CID) || null,
    uid: getShopifyUserId(),
    timestamp: new Date().getTime(),
    source: d.source || 'CartseeAssociation',
    sourceLocation: d.sourceLocation || 'CustomerService'
  };
  post({
    url: CARTXTRACK_URL,
    contentType: 'application/json',
    data: JSON.stringify(p)
  });
}
